module.exports = __webpack_public_path__ + "img/default-lu-cover.e240bdba.jpg";